import { parseISO, format } from 'date-fns';
import { pt, fr, es, enUS } from 'date-fns/locale';
export function getFormattedDate(apiDate, lang) {
    const publicationDate = apiDate ? parseISO(apiDate) : null;
    if (!publicationDate)
        return null;
    const formatedDate = format(publicationDate, 'dd MMMM, yyyy', {
        locale: getDateFnsLocaleFromLang(lang)
    });
    return formatedDate;
}
function getDateFnsLocaleFromLang(lang) {
    switch (lang) {
        case 'pt':
            return pt;
        case 'fr':
            return fr;
        case 'es':
            return es;
        case 'en':
            return enUS;
        default:
            return pt;
    }
}
